import Icon, { type IconString } from '2-core-elements/Icon/Icon';
import clsx from 'clsx';
import { type FC, type ReactNode } from 'react';

interface TagProps {
    size?: 'sm' | 'md' | 'lg';
    type?: 'primary' | 'greyscale';
    tagStyle?: 'bold' | 'subtle' | 'outlined';
    label: string;
    prefixIcon?: IconString;
    showCheckIcon?: boolean;
    showDismissIcon?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    className?: string;
    children?: ReactNode;
    ariaLabel?: string;
}

const Tag: FC<TagProps> = ({
    size = 'md',
    type = 'primary',
    tagStyle = 'bold',
    label,
    prefixIcon,
    showCheckIcon = false,
    showDismissIcon = false,
    onClick,
    onKeyDown,
    className,
    children,
    ariaLabel,
}) => {
    const tagClassName = clsx(
        'tag',
        className,
        size ? `${size}` : null,
        type ? type : 'primary',
        tagStyle ? tagStyle : 'bold'
    );

    return (
        <div
            className={tagClassName}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={onKeyDown}
            aria-label={ariaLabel}
        >
            {prefixIcon && (
                <Icon icon={prefixIcon} />
            )}
            <span className="tag-label">
                {label}{children}
            </span>
            {showCheckIcon && (
                <Icon icon="check" />
            )}
            {showDismissIcon && (
                <Icon icon="close" />
            )}
        </div>
    );
};

export default Tag;
